/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OffsetInputs */



/**
* | output |
* | --- |
* | "Offset" |
*
* @param {OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offset = /** @type {((inputs?: OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décalage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компенсировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compensar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("抵消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओफ़्सेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desvio")
	return /** @type {LocalizedString} */ ("Offset")
});